//import core from "core";
import * as fs from "filesystem";
import sleep from "sleep";

/* an async generator that reads the input file chunk by chunk and yields each line */
export async function *readline(path, backward=false) {
  const MAXCHUNKSIZE = 5000;
  var lines = [""];

  var size = fs.statSync(path).size-1;
  var position = backward ? size-MAXCHUNKSIZE : 0;
  var chunk;

  do {
    chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      position: position,
      length: MAXCHUNKSIZE
    })) );

    position += backward ? -MAXCHUNKSIZE : MAXCHUNKSIZE;

    chunk = chunk.split("\n");
    
    if (backward) chunk = chunk.reverse();
    lines[0] += chunk.shift();    
    lines = lines.concat(chunk);

    while(lines.length-1) {
      await sleep(0);
      yield lines.shift();
    }

  } while(backward ? position>=0 : position<size);

  return lines.shift();
}